import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ApiService } from '@core/api/api.service';

type SidebarVersionState = 'idle' | 'loading' | 'ready' | 'error';

@Injectable({
  providedIn: 'root',
})
export class SidebarVersionService {
  private apiService = inject(ApiService);

  readonly version = signal('...');
  readonly state = signal<SidebarVersionState>('idle');
  readonly errorMessage = signal<string | null>(null);
  readonly isLoading = computed(() => this.state() === 'loading');

  async loadVersion(): Promise<void> {
    if (this.state() === 'loading') {
      return;
    }

    this.state.set('loading');
    this.errorMessage.set(null);

    try {
      const version = await firstValueFrom(this.apiService.getVersion());
      this.version.set(version || 'N/A');
      this.state.set('ready');
    } catch {
      this.version.set('N/A');
      this.errorMessage.set('Nie udało się pobrać wersji backendu.');
      this.state.set('error');
    }
  }
}
